var merge = require('lodash/merge')
import { reactive, readonly } from 'vue'

const config = reactive({})
const agentInfo = reactive({
  name: null,
  type: null,
  version: null,
  avatarUrl: null,
})

function setConfig(configObject) {
  merge(config, configObject)
}

function addConfig(key, value) {
  config[key] = value
}

function removeConfig(key) {
  delete config[key]
}

function setAgentInfo(agentData) {
  if (agentData) {
    agentInfo.name = agentData.metadata?.name || null
    agentInfo.type = agentData.agent_type || null
    agentInfo.version = agentData.version_number || null
    agentInfo.avatarUrl = agentData.metadata?.avatar_url || null
  }
}

function getBotDisplayName() {
  return agentInfo.name || 'Generated by OvationCXM AI'
}

function getBotAvatarUrl() {
  return agentInfo.avatarUrl || '/images/bot-avatar.png'
}

export const partnerStore = readonly({
  config,
  agentInfo,
  setConfig,
  addConfig,
  removeConfig,
  setAgentInfo,
  getBotDisplayName,
  getBotAvatarUrl,
})
